import { HttpClient } from '@/shared';
import AppUser from '../../application/domain/entities/appUser';
import IUserRepository from '../../application/ports/outbound/IUserRepository';
import UserDto from '../dto/userDto';
import { mapUserDtoToAppUser } from '../mapper/userMapper';

export class ApiUserRepository implements IUserRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async searchUsers(searchKey: string, signal?: AbortSignal): Promise<AppUser[]> {
    const response = await this.httpClient.get<Array<UserDto>>(`/app-users?search=${searchKey}`, {
      signal,
    });
    return response.data.map(mapUserDtoToAppUser);
  }
}

export default ApiUserRepository;
